import { React, useState, useEffect, useContext } from "react";
import styles from "../PCMain.module.css";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";
import Moment from 'moment';
import "moment/locale/ko";
import { Chart } from "react-google-charts";
import { useNavigate, useLocation } from "react-router-dom";

const MachineMonitoring = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [machineReady, setMachineReady] = useState('N');
    const [machine, setMachine] = useState([]);
    const [projectPie, setProjectPie] = useState(
        [[
        ["비율", "프로젝트"],
        [0, ""]
        ],
        [
        ["비율", "프로젝트"],
        [0, ""]
        ]]
    );
    const projectPie_option = {
        title: "프로젝트",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["rgb(232, 176, 141)","rgb(206, 141, 232)","rgb(141, 231, 232)"
            , "rgb(232, 141, 141)", "rgb(151, 236, 91)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [runPie, setRunPie] = useState(
        [[
            ["비율", "가동상태"],
            ["가동", 1],
            ["정지", 1],
            ["홀드", 1],
            ["MSRT", 1],
            ["오프라인", 1]
        ],[
            ["비율", "가동상태"],
            ["가동", 1],
            ["정지", 1],
            ["홀드", 1],
            ["MSRT", 1],
            ["오프라인", 1]
        ]]
    );
    const runPie_option = {
        title: "가동상태",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["rgb(104, 171, 38)","#D84B16","#FFB737","#F1A7C9", "rgb(57, 54, 54)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [autPie, setAutPie] = useState(
        [[
            ["비율", "가동모드"],
            ["MDI", 1],
            ["MEM", 1],
            ["EDIT", 1],
            ["HND", 1],
            ["JOG", 1],
            ["REF", 1],
            ["ETC", 1],
        ],[
            ["비율", "가동모드"],
            ["MDI", 1],
            ["MEM", 1],
            ["EDIT", 1],
            ["HND", 1],
            ["JOG", 1],
            ["REF", 1],
            ["ETC", 1],
        ]]
    );
    const autPie_option = {
        title: "가동모드",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["rgb(245, 123, 123)", "rgb(232, 215, 105)","rgb(128, 236, 104)","rgb(88, 136, 233)", "rgb(212, 95, 239)", "rgb(57, 54, 54)", "rgb(211, 141, 43)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [statusPie, setStatusPie] = useState([]);
    const statusPie_option = {
        title: "가동상태",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["rgb(104, 171, 38)","#D84B16"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [errorPie, setErrorPie] = useState([]);
    const errorPie_option = {
        title: "불량율",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["#2196F3","#F44336"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [errorTypePie, setErrorTypePie] = useState([]);
    const errorTypePie_option = {
        title: "불량유형",
        titleTextStyle: { fontSize: 18, fontName: 'Arial',},
        colors: ["#D84B16","#FFB737","rgb(232, 141, 141)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [timeLineData, setTimeLineData] = useState([
            [
                { type: "string", id: "Room" },
                { type: "string", id: "Name" },
                { type: "date", id: "Start" },
                { type: "date", id: "End" },
            ],
            [
                "기간",
                "오프라인",
                new Date(0, 0, 0, 0, 0, 0),
                new Date(0, 0, 0, 8, 0, 0),
            ],
            [
                "기간",
                "가동",
                new Date(0, 0, 0, 8, 0, 0),
                new Date(0, 0, 0, 16, 0, 0),
            ],
            [
                "기간",
                "정지",
                new Date(0, 0, 0, 16, 0, 0),
                new Date(0, 0, 0, 24, 0, 0),
            ],
    ]);
    const [timeLineOption, setTimeLineOption] = useState({
        timeline: { showRowLabels: false },
        avoidOverlappingGridLines: false,
        colors: ["#cbb69d", "#603913", "#c69c6e"],
    });
    
    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        };

        const timer = setInterval(() => {
            handleView();
        }, 60000);
    
        return () => {
          clearInterval(timer);
        };
    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView()
        }
    }, [MenuID]);

    // 설비 데이터 조회
    const handleView = async () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        try {
            // 1) 첫 조회
            const resp = await axios.get('/api/p/MachineMonitoring/Select');
            const rows = resp?.data ?? [];

            // === 가공 결과 컨테이너 ===
            const machineInfo = [];
            const status_array = [];
            const error_array = [];
            const error_type_array = [];

            let hasType1 = false;

            // 2) 행 단위 가공
            for (let i = 0; i < rows.length; i++) {
                const data = rows[i];

                if (String(data.machine_type) === '1') hasType1 = true;

                // 공통 임시값
                let temp_percent = 0;
                let temp_percent_color = 'white';

                // run/aut 상태 계산
                const temp_status_run = (data.status_run !== undefined ? data.status_run : data.status);
                let temp_status_run_name = '';
                let temp_status_run_color = 'white';

                const temp_status_aut = data.status_aut;
                let temp_status_aut_name = '';

                // === 타입별 처리 ===
                if (data.machine_type == '1') {
                    // (1) 달성률 색상 계산
                    if (Number(data.sum_produce_count) > 0) {
                        const target = Number(data.target_count) || 0;
                        const produce = Number(data.produce_count) || 0;
                        if (target > 0) temp_percent = Math.floor((produce / target) * 100);

                        if (temp_percent >= 100) {
                            temp_percent = 100;
                            temp_percent_color = 'rgb(90, 150, 70)';   // 안정
                        }
                        if (temp_percent <= 50) {
                            temp_percent_color = 'rgb(200, 80, 80)';   // 위험
                        } else if (temp_percent > 50 && temp_percent <= 80) {
                            temp_percent_color = 'rgb(210, 140, 60)';  // 주의
                        } else if (temp_percent > 80 && temp_percent <= 99) {
                            temp_percent_color = 'rgb(160, 150, 80)';  // 거의 안정
                        }
                    }

                    // (2) 가동상태 이름/색상
                    if (temp_status_run == 0) {
                        temp_status_run_name = '오프라인'; temp_status_run_color = 'rgb(57, 54, 54)';
                    } else if (temp_status_run == 1) {
                        temp_status_run_name = '정지'; temp_status_run_color = '#D84B16';
                    } else if (temp_status_run == 2) {
                        temp_status_run_name = '홀드'; temp_status_run_color = '#FFB737';
                    } else if (temp_status_run == 3) {
                        temp_status_run_name = '가동'; temp_status_run_color = 'rgb(104, 171, 38)';
                    } else if (temp_status_run == 4) {
                        temp_status_run_name = 'MSTR'; temp_status_run_color = '#F1A7C9';
                    } else if (temp_status_run == -1) {
                        temp_status_run_name = '미 연결'; temp_status_run_color = 'rgba(100,116,139,.5)';
                    } else {
                        temp_status_run_name = ''; temp_status_run_color = '#bdbdbd';
                    }

                    // (3) 가동모드 이름
                    if (temp_status_aut == '0') temp_status_aut_name = 'MDI';
                    else if (['10','2','6','7','8'].includes(String(temp_status_aut))) temp_status_aut_name = 'ETC';
                    else if (temp_status_aut == '3') temp_status_aut_name = 'EDIT';
                    else if (temp_status_aut == '4') temp_status_aut_name = 'HND';
                    else if (temp_status_aut == '5') temp_status_aut_name = 'JOG';
                    else if (temp_status_aut == '9') temp_status_aut_name = 'REF';
                    else if (temp_status_aut == '1') temp_status_aut_name = 'MEM';
                    else if (temp_status_aut == -1) temp_status_aut_name = '미 연결';
                    else temp_status_aut_name = '';

                } else if (data.machine_type == '2' || data.machine_type == '4') {
                    // (1) 달성률 색상 계산 (sum_produce_count / target_count)
                    if (Number(data.sum_produce_count) > 0) {
                        const target = Number(data.target_count) || 0;
                        const sumProd = Number(data.sum_produce_count) || 0;
                        if (target > 0) temp_percent = Math.floor((sumProd / target) * 100);

                        if (temp_percent >= 100) {
                            temp_percent = 100;
                            temp_percent_color = 'rgb(90, 150, 70)';   // 안정
                        }
                        if (temp_percent <= 50) {
                            temp_percent_color = 'rgb(200, 80, 80)';   // 위험
                        } else if (temp_percent > 50 && temp_percent <= 80) {
                            temp_percent_color = 'rgb(210, 140, 60)';  // 주의
                        } else if (temp_percent > 80 && temp_percent <= 99) {
                            temp_percent_color = 'rgb(160, 150, 80)';  // 거의 안정
                        }
                    }

                    // (2) 가동상태 이름/색상 (2/4 전용)
                    if (temp_status_run == 0) {
                        temp_status_run_name = '정지'; temp_status_run_color = '#D84B16';
                    } else if (temp_status_run == 1) {
                        temp_status_run_name = '가동'; temp_status_run_color = 'rgb(104, 171, 38)';
                    } else if (temp_status_run == -1) {
                        temp_status_run_name = '미 연결'; temp_status_run_color = 'rgba(100,116,139,.5)';
                    } else {
                        temp_status_run_name = ''; temp_status_run_color = '#bdbdbd';
                    }
                }

                // (4) 화면에 쓸 기계 정보 push
                if (data.machine_type == '1' || data.machine_type == '2' || data.machine_type == '4') {
                    machineInfo.push({
                        machine_id: data.machine_id,
                        machine_name: data.machine_name,
                        machine_type: data.machine_type,
                        machine_max_datetime: data.max_datetime,
                        target_count: (typeof data.target_count === 'undefined' ? "0" : data.target_count),
                        produce_count: (typeof data.produce_count === 'undefined' ? "0" : data.produce_count),
                        project_number: (typeof data.project_number === 'undefined' ? "" : data.project_number),
                        project_name: (typeof data.project_name === 'undefined' ? "" : data.project_name),
                        progress_percent: (typeof data.produce_count === 'undefined' && typeof data.sum_produce_count === 'undefined') ? "0" : temp_percent,
                        progress_percent_color: temp_percent_color,
                        run_status: temp_status_run_name,
                        run_color: temp_status_run_color,
                        aut_status: temp_status_aut_name,
                        sum_produce_time: data.sum_produce_time,
                        sum_produce_count: data.sum_produce_count,
                        sum_ok_count: (typeof data.sum_ok_count === 'undefined' ? "0" : data.sum_ok_count),
                        sum_ng_count: (typeof data.sum_ng_count === 'undefined' ? "0" : data.sum_ng_count),
                        ng1_count: (typeof data.ng1_count === 'undefined' ? "0" : data.ng1_count),
                        ng2_count: (typeof data.ng2_count === 'undefined' ? "0" : data.ng2_count),
                        ng3_count: (typeof data.ng3_count === 'undefined' ? "0" : data.ng3_count),
                        ng1_label: (typeof data.ng1_label === 'undefined' ? "" : data.ng1_label),
                        ng2_label: (typeof data.ng2_label === 'undefined' ? "" : data.ng2_label),
                        ng3_label: (typeof data.ng3_label === 'undefined' ? "" : data.ng3_label),
                    });

                    if(data.machine_type == '2'){
                        // 타임라인 데이터 호출
                        axios.get('/api/p/MachineRuningStatus/TimeLineData',
                            {
                                params : {
                                    id : data.machine_id
                                }
                            },
                            { withCredentials: true }
                        )
                        .then((response2) => {
                            let temp_array = [ // 타임라인 데이터 임시 배열
                                [
                                    { type: "string", id: "Room" },
                                    { type: "string", id: "Name" },
                                    { type: "date", id: "Start" },
                                    { type: "date", id: "End" },
                                ],
                            ]
                            let temp_color_array = [] // 타임라인 색상 임시 배열
                            // 마지막 24시를 위한 임시데이터
                            let last_hour = ''
                            let last_min = ''
                            let last_sec = ''
                            let temp_start_hour = '';
                            let temp_start_min = '';
                            let temp_start_sec = '';
                            let temp_end_hour = '';
                            let temp_end_min = '';
                            let temp_end_sec = '';
                            let temp_status = '';
                            let temp_status_name = '';
                            let temp_status_color = '';

                            let status_0 = 'N';
                            let status_1 = 'N';
                            let status_2 = 'N';
                            let status_3 = 'N';
                            let status_4 = 'N'; 
                            for(let i = 0; i < response2.data.length; i++) {
                                let addYN = 'N';
                                let data = response2.data[i];

                                if(data.status_run !== temp_status){
                                    temp_start_hour = Moment(data.start_datetime).format('HH');
                                    temp_start_min = Moment(data.start_datetime).format('mm');
                                    temp_start_sec = Moment(data.start_datetime).format('ss');
                                }
                                
                                temp_status = data.status_run;
                                
                                if(i === (response2.data).length-1 || temp_status !== (response2.data[i+1]).status_run){
                                    
                                    addYN = 'Y'
                                    temp_end_hour = Moment(data.end_datetime).format('HH');
                                    temp_end_min = Moment(data.end_datetime).format('mm');
                                    temp_end_sec = Moment(data.end_datetime).format('ss');

                                    if(String(data.machine_type) === '1'){
                                        //run 동작상태 # 0 : 오프라인 , 1 : 정지 , 2 : 홀드 , 3 : 가동 , 4 : MSTR
                                        if(Number(temp_status) === 0 || Number(temp_status) === -1){
                                            temp_status_name = '오프라인'
                                            temp_status_color = 'rgb(57, 54, 54)'
                                            if(status_0 === 'N'){
                                                temp_color_array = temp_color_array.concat('rgb(57, 54, 54)')
                                            }
                                            status_0 = 'Y'
                                        } else if (Number(temp_status) === 1){
                                            temp_status_name = '정지'
                                            temp_status_color = '#D84B16'
                                            if(status_1 === 'N'){
                                                temp_color_array = temp_color_array.concat('#D84B16')
                                            }
                                            status_1 = 'Y'
                                        } else if (Number(temp_status) === 2){
                                            temp_status_name = '홀드'
                                            temp_status_color = '#FFB737'
                                            if(status_2 === 'N'){
                                                temp_color_array = temp_color_array.concat('#FFB737')
                                            }
                                            status_2 = 'Y'
                                        } else if (Number(temp_status) === 3){
                                            temp_status_name = '가동'
                                            temp_status_color = 'rgb(104, 171, 38)'
                                            if(status_3 === 'N'){
                                                temp_color_array = temp_color_array.concat('rgb(104, 171, 38)')
                                            }
                                            status_3 = 'Y'
                                        } else if (Number(temp_status) === 4){
                                            temp_status_name = 'MSTR'
                                            temp_status_color = '#F1A7C9'
                                            if(status_4 === 'N'){
                                                temp_color_array = temp_color_array.concat('#F1A7C9')
                                            }
                                            status_4 = 'Y'
                                        }
                                    } else if(String(data.machine_type) === '2' || String(data.machine_type) === '4'){
                                        if (Number(temp_status) === 0 || Number(temp_status) === -1){
                                            temp_status_name = '정지'
                                            temp_status_color = '#D84B16'
                                            if(status_1 === 'N'){
                                                temp_color_array = temp_color_array.concat('#D84B16')
                                            }
                                            status_1 = 'Y'
                                        } else if (Number(temp_status) === 1){
                                            temp_status_name = '가동'
                                            temp_status_color = 'rgb(104, 171, 38)'
                                            if(status_3 === 'N'){
                                                temp_color_array = temp_color_array.concat('rgb(104, 171, 38)')
                                            }
                                            status_3 = 'Y'
                                        }
                                    }
                                }
                                

                                if(addYN === 'Y'){
                                    let temp_data = [[ // 이번에 들어갈 데이터
                                        "기간",
                                        temp_status_name,
                                        new Date(0, 0, 0, temp_start_hour, temp_start_min, temp_start_sec),
                                        new Date(0, 0, 0, temp_end_hour, temp_end_min, temp_end_sec),
                                    ]]
                                    if(temp_start_hour||'$'||temp_start_min||'$'||temp_start_sec !== temp_end_hour||'$'||temp_end_min||'$'||temp_end_sec){
                                        temp_array = temp_array.concat(temp_data)
                                    }
                                }
                            }
                            
                            // 마지막 24시를 위한 임시데이터
                            last_hour = temp_end_hour;
                            last_min = temp_end_min;
                            last_sec = temp_end_sec;
                            let temp_data = [[
                                // 마지막 24시간 데이터 추가
                                "기간",
                                '데이터 수집중',
                                new Date(0, 0, 0, last_hour, last_min, last_sec),
                                new Date(0, 0, 0, 24, 0, 0),
                            ]]
                            temp_array = temp_array.concat(temp_data)
                            temp_color_array = temp_color_array.concat('rgb(255, 255, 255)')
                            
                            setTimeLineOption(
                                {
                                    timeline: { showRowLabels: false },
                                    avoidOverlappingGridLines: false,
                                    colors: temp_color_array,
                                }
                            )
                            setTimeLineData(temp_array)
                        })
                        .catch((error) => {
                            appStore.capture();
                        })
                    }
                    
                    // (5) 파이 차트용 배열들 정렬(인덱스 맞추기)
                    if (data.machine_type == '2' || data.machine_type == '4') {
                        status_array.push([
                            ["상태", "가동율"],
                            ["가동", data.run_min ?? 0],
                            ["정지", data.stop_min ?? 0],
                        ]);
                        error_array.push([
                            ["상태", "불량율"],
                            ["OK", data.sum_ok_count ?? 0],
                            ["NG", data.sum_ng_count ?? 0],
                        ]);
                    } else {
                        status_array.push(null);
                        error_array.push(null);
                    }

                    if (data.machine_type == '4') {
                        error_type_array.push([
                            ["상태", "불량유형"],
                            [data.ng1_label, data.ng1_count ?? 0],
                            [data.ng2_label, data.ng2_count ?? 0],
                            [data.ng3_label, data.ng3_count ?? 0],
                        ]);
                    } else {
                        error_type_array.push(null);
                    }
                }
            }

            // 3) 1차 상태 반영
            setStatusPie(status_array);
            setErrorPie(error_array);
            setErrorTypePie(error_type_array);
            setMachine(machineInfo);

            // 4) type=1 설비 없으면 하위 API 스킵/초기화
            if (!hasType1) {
                setProjectPie([]);
                setAutPie([]);
                setRunPie([]);
                setMachineReady('Y');
                return;
            }

            // 5) type=1 있을 때만 병렬 호출
            const [projRes, autRes, runRes] = await Promise.all([
                axios.get('/api/p/MachineMonitoring/SelectProjectName'),
                axios.get('/api/p/MachineMonitoring/SelectAutStatus'),
                axios.get('/api/p/MachineMonitoring/SelectRunStatus'),
            ]);

            // --- 프로젝트 파이 ---
            {
                const list = projRes?.data ?? [];
                let full_array = [];
                let temp_array = [];
                let data_machine_id = '0';

                for (let i = 0; i < list.length; i++) {
                    const d = list[i];
                    if (d.machine_id !== data_machine_id) {
                        full_array.push(temp_array);
                        data_machine_id = d.machine_id;
                        temp_array = [["비율", "프로젝트"]];
                    }
                    temp_array = temp_array.concat([[d.project_name, d.sum_produce_count]]);
                }
                full_array.push(temp_array);
                full_array.splice(0, 1);
                setProjectPie(full_array);
            }

            // --- 가동모드 파이 ---
            {
                const list = autRes?.data ?? [];
                let MDI = 0, EDIT = 0, HND = 0, JOG = 0, REF = 0, MEM = 0, ETC = 0;
                let full_array = [];
                let data_machine_id = '0';

                for (let i = 0; i < list.length; i++) {
                    const d = list[i];
                    if (d.machine_id !== data_machine_id) {
                        if (data_machine_id !== '0') {
                            full_array.push([
                            ["비율", "가동모드"],
                            ["MDI", MDI], ["MEM", MEM], ["EDIT", EDIT],
                            ["HND", HND], ["JOG", JOG], ["REF", REF], ["ETC", ETC],
                            ]);
                        }
                        data_machine_id = d.machine_id;
                        MDI = EDIT = HND = JOG = REF = MEM = ETC = 0;
                    }

                    if (d.status_aut === '0') MDI = d.sum_produce_time;
                    else if (['10','2','6','7','8'].includes(d.status_aut)) ETC += d.sum_produce_time;
                    else if (d.status_aut === '3') EDIT = d.sum_produce_time;
                    else if (d.status_aut === '4') HND = d.sum_produce_time;
                    else if (d.status_aut === '5') JOG = d.sum_produce_time;
                    else if (d.status_aut === '9') REF = d.sum_produce_time;
                    else if (d.status_aut === '1') MEM = d.sum_produce_time;
                }

                full_array.push([
                    ["비율", "가동모드"],
                    ["MDI", MDI], ["MEM", MEM], ["EDIT", EDIT],
                    ["HND", HND], ["JOG", JOG], ["REF", REF], ["ETC", ETC],
                ]);
                setAutPie(full_array);
                setMachineReady('Y');
            }

            // --- 가동상태 파이 ---
            {
                const list = runRes?.data ?? [];
                let reset = 0, stop = 0, hold = 0, start = 0, mstr = 0;
                let full_array = [];
                let data_machine_id = '0';

                for (let i = 0; i < list.length; i++) {
                    const d = list[i];
                    if (d.machine_id !== data_machine_id) {
                        if (data_machine_id !== '0') {
                            full_array.push([
                            ["상태", "가동상태"],
                            ["가동", start], ["정지", stop], ["홀드", hold],
                            ["MSTR", mstr],         // MSRT 오타 방지
                            ["오프라인", reset],
                            ]);
                        }
                        data_machine_id = d.machine_id;
                        reset = stop = hold = start = mstr = 0;
                    }

                    if (d.status_run === '0') reset = d.sum_produce_time;
                    else if (d.status_run === '1') stop = d.sum_produce_time;
                    else if (d.status_run === '2') hold = d.sum_produce_time;
                    else if (d.status_run === '3') start = d.sum_produce_time;
                    else if (d.status_run === '4') mstr = d.sum_produce_time;
                }

                full_array.push([
                    ["상태", "가동상태"],
                    ["가동", start], ["정지", stop], ["홀드", hold],
                    ["MSTR", mstr],
                    ["오프라인", reset],
                ]);
                setRunPie(full_array);
            }
        } catch (e) {
            try { appStore?.capture?.(e); } catch {}
            console.error(e);
        }finally {
           appStore.setLoading(false);
        };
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            { (machine.length > 0)?
            <>
            <div className="grid" style={ { top: '0px', overflowY:'visible' } }>
                
                {machine.map((item, index) => (
                    <div key={index} style={{float: 'left', width: '99%', height: '196px', margin: '5px', border: '2px solid #bdbdbd'}}>
                        <div style={{float: 'left', border: '3px solid #bdbdbd',  width: '450px'}}>
                            <div style={ { height: '36px', backgroundColor: `${item.run_color}`, padding: '3px' } }>
                                <div style={{float: 'left', fontWeight: 'bold', fontSize: '22px', color: 'white'}}>
                                    {item.machine_name}
                                </div>
                                <div style={{float: 'right', fontWeight: 'bold', fontSize: '18px', color: 'white', paddingTop: '5px'}}>
                                    {item.project_name?.trim() ? item.project_name : item.run_status + ' [ '+item.machine_max_datetime+' ]' }
                                </div>
                            </div>
                            {((item.machine_type == '4' && item.sum_produce_count > 0 && item.target_count > 0) || (item.machine_type == '1' && item.produce_count > 0 && item.target_count > 0))?
                            <>
                            {/* 생산 카운트 */}
                            {(item.machine_type == '1')?
                            <div style={{ height: '30px', padding: '5px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>
                                <span>{Number(item.produce_count).toLocaleString()} / {Number(item.target_count).toLocaleString()}</span>
                            </div>
                            :
                            (item.machine_type == '4')?
                            <div style={{ height: '30px', padding: '5px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>
                                <span>{Number(item.sum_produce_count).toLocaleString()} / {Number(item.target_count).toLocaleString()}</span>
                            </div>
                            :
                            <></>
                            }

                            {/* 진행바 + 퍼센트 */}
                            <div className="progress-row">
                                <div className="progress-shell">
                                    <div className="progress-track">
                                        <i style={{ width: `${item.progress_percent}%`, background: item.progress_percent_color }} />
                                    </div>
                                </div>
                                <div className="progress-label">
                                    {item.progress_percent}%
                                </div>
                            </div>
                            </>
                            :
                            <>
                            {(item.machine_type == '2')?
                            <div style={ { height: '146px', padding: '3px', textAlign:'center', fontWeight: 'bold', paddingTop: '25px' } }>
                                <span className={`badge ${
                                    item.run_status === "가동"   ? "run" :
                                    item.run_status === "정지"     ? "stop" :
                                    item.run_status === "홀드"     ? "hold" :
                                    item.run_status === "오프라인" ? "offline" :
                                    item.run_status === "MSTR"    ? "mstr" :
                                    item.run_status === "미 연결"    ? "notconnect" :
                                    "etc"
                                }`} style={ { width: '300px', height: '100px', fontSize: '58px' } }>
                                    {item.run_status}
                                </span>
                            </div>
                            :
                            <div style={ { height: '70px', padding: '3px', textAlign:'center', fontWeight: 'bold', paddingTop: '8px' } }>
                                <span className={`badge ${
                                    item.run_status === "가동"   ? "run" :
                                    item.run_status === "정지"     ? "stop" :
                                    item.run_status === "홀드"     ? "hold" :
                                    item.run_status === "오프라인" ? "offline" :
                                    item.run_status === "MSTR"    ? "mstr" :
                                    item.run_status === "미 연결"    ? "notconnect" :
                                    "etc"
                                }`} style={ { width: '300px', height: '55px', fontSize: '32px' } }>
                                    {item.run_status}
                                </span>
                            </div>}
                            </>
                            }
                            <div style={{ textAlign:'center', padding: '3px', paddingTop: '3px' }}>
                                {(item.machine_type == '1')?
                                <table className="machine-table">
                                    <tbody>
                                    <tr>
                                        <td className="label">생산수량</td>
                                        <td className="value num">{item.sum_produce_count}</td>
                                        <td className="label">생산시간</td>
                                        <td className="value">{item.sum_produce_time}</td>
                                    </tr>
                                    <tr>
                                        <td className="label">가동상태</td>
                                        <td className="value">
                                        <span className={`badge ${
                                            item.run_status === "가동"   ? "run" :
                                            item.run_status === "정지"     ? "stop" :
                                            item.run_status === "홀드"     ? "hold" :
                                            item.run_status === "오프라인" ? "offline" :
                                            item.run_status === "MSTR"    ? "mstr" :
                                            item.run_status === "미 연결"    ? "notconnect" :
                                            "etc"
                                        }`}>
                                            {item.run_status}
                                        </span>
                                        </td>
                                        <td className="label">가동모드</td>
                                        <td className="value">
                                        <span className={`badge ${
                                            item.aut_status === "MDI"  ? "mdi" :
                                            item.aut_status === "MEM"  ? "mem" :
                                            item.aut_status === "EDIT" ? "edit" :
                                            item.aut_status === "HND"  ? "hnd" :
                                            item.aut_status === "JOG"  ? "jog" :
                                            item.aut_status === "REF"  ? "ref" :
                                            item.aut_status === "ETC"  ? "etc-mode" :
                                            item.aut_status === "미 연결"   ? "notconnect" :
                                            "etc-mode"
                                        }`}>
                                            {item.aut_status}
                                        </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                :
                                (item.machine_type == '4')?
                                <table className="machine-table" style={{ width: "100%" }}>
                                    <colgroup>
                                        {/* 1세트 */}
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "6.6667%" }} />
                                        <col style={{ width: "6.6667%" }} />

                                        {/* 2세트 */}
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "6.6667%" }} />
                                        <col style={{ width: "6.6667%" }} />
                                    </colgroup>
                                    <tbody>
                                        <tr style={ { height:'35px' } }>
                                            <td className="label" style={{ width: "125px", color: 'blue' }} colSpan={3}>OK</td>
                                            <td className="value num" style={{ width: "100px" }} colSpan={3}>{Number(item.sum_ok_count).toLocaleString()}</td>
                                            <td className="label" style={{ width: "125px", color: 'red' }} colSpan={3}>NG</td>
                                            <td className="value num" style={{ width: "100px" }} colSpan={3}>{Number(item.sum_ng_count).toLocaleString()}</td>
                                        </tr>
                                        <tr style={ { height:'39px' } }>
                                            <td className="label" style={{ width: "85px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng1_label}</td>
                                            <td className="value num" style={{ width: "65px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng1_count}</td>
                                            <td className="label" style={{ width: "85px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng2_label}</td>
                                            <td className="value num" style={{ width: "65px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng2_count}</td>
                                            <td className="label" style={{ width: "85px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng3_label}</td>
                                            <td className="value num" style={{ width: "65px", fontSize: '14px', padding: '3px', fontWeight:'normal' }} colSpan={2}>{item.ng3_count}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                :
                                <></>
                                }
                            </div>
                        </div>
                        {(item.machine_type == '1')?
                        <div className={styles.hideOnSmall} style={{display:'flex', height:'200px', marginLeft:'10px'}}>
                            <div className={styles.pieChart1} style={{float: 'left',  width: '380px', height: '200px', marginLeft:'10px'}}>
                                {machineReady === 'Y'?
                                <div style={{ width: '100%', height: '190px' }}>
                                    <Chart
                                        chartType="PieChart"
                                        data={runPie[index]}
                                        options={runPie_option}
                                        width={"100%"}
                                        height={"190px"}
                                    />
                                </div>
                                :''}
                            </div>
                            <div className={styles.pieChart2} style={{float: 'left',  width: '380px', height: '200px', marginLeft:'10px'}}>
                                {machineReady === 'Y'?
                                <div style={{ width: '100%', height: '190px' }}>
                                    <Chart
                                        chartType="PieChart"
                                        data={autPie[index]}
                                        options={autPie_option}
                                        width={"100%"}
                                        height={"190px"}
                                    />
                                </div>
                                :''}
                            </div>
                            <div className={styles.pieChart3} style={{float: 'left',  width: '380px', height: '200px', marginLeft:'10px'}}>
                                {machineReady === 'Y'?
                                <div style={{ width: '100%', height: '190px' }}>
                                    <Chart
                                        chartType="PieChart"
                                        data={projectPie[index]}
                                        options={projectPie_option}
                                        width={"100%"}
                                        height={"190px"}
                                    />
                                </div>
                                :''}
                            </div>
                        </div>
                        :
                        (item.machine_type == '2' || item.machine_type == '4')?
                        <div className={styles.hideOnSmall} style={{display:'flex', height:'200px', marginLeft:'10px'}}>
                            <div className={styles.pieChart1} style={{float: 'left',  width: '380px', height: '200px', marginLeft:'10px'}}>
                                {machineReady === 'Y'?
                                <div style={{ width: '100%', height: '190px' }}>
                                    <Chart
                                        chartType="PieChart"
                                        data={statusPie[index]}
                                        options={statusPie_option}
                                        width={"100%"}
                                        height={"190px"}
                                    />
                                </div>
                                :''}
                            </div>
                            {item.machine_type == '2'?
                            <>
                            <div className={styles.pieChart2} style={{float: 'left',  width: '770px', height: '200px', marginLeft:'10px'}}>
                                <p style={ { fontSize:'18px', fontWeight:'bold', padding:'0px', marginTop:'5px' } }>
                                    가동시간
                                </p>
                                <div style={{ paddingTop:'15px' }}>
                                    <Chart
                                        chartType="Timeline"
                                        data={timeLineData}
                                        options={timeLineOption}
                                        width="100%"
                                        height="100px"
                                    />
                                </div>
                            </div>
                            </>
                            :
                            <>
                            <div className={styles.pieChart2} style={{float: 'left',  width: '380px', height: '200px', marginLeft:'10px'}}>
                                {machineReady === 'Y'?
                                <div style={{ width: '100%', height: '190px' }}>
                                    <Chart
                                        chartType="PieChart"
                                        data={errorPie[index]}
                                        options={errorPie_option}
                                        width={"100%"}
                                        height={"190px"}
                                    />
                                </div>
                                :''}
                            </div>
                            <div className={styles.pieChart3} style={{float: 'left',  width: '380px', height: '200px', marginLeft:'10px'}}>
                                {machineReady === 'Y'?
                                <div style={{ width: '100%', height: '190px' }}>
                                    <Chart
                                        chartType="PieChart"
                                        data={errorTypePie[index]}
                                        options={errorTypePie_option}
                                        width={"100%"}
                                        height={"190px"}
                                    />
                                </div>
                                :''}
                            </div>
                            </>}
                        </div>:<></>}
                    </div>
                ))}
            </div>
            </>
            : <></>}
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MachineMonitoring;